export enum TranCategory {
  TRADE = 'TRADE',
  TRANSFER = 'TRANSFER',
  CASH_ENTRY = 'CASH_ENTRY',
  FX_TRADE = 'FX_TRADE',
  CURRENCY_FORWARD = 'CURRENCY_FORWARD',
  DIRECT_TRANSFER = 'DIRECT_TRANSFER',
  OTHER = 'OTHER',
}

export type MatchExternalTranCategory =
  | TranCategory.TRADE
  | TranCategory.CASH_ENTRY
